import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS, ROUTE_PATHS } from '@constants';
import { useStore } from '@hooks';
import { Icon } from '@ui';
import { observer } from 'mobx-react';
import EmailIcon from '../../../../assets/svg/email.svg?react';
import SpecificProductsIcon from '../../../../assets/svg/specificProducts.svg?react';
import InviteDeveloperModal from './components/InviteDeveloperModal';
import {
    ButtonsContainer,
    ChartArea,
    ChartCard,
    Container,
    DescriptionText,
    PrimaryButton,
    SecondaryButton,
    SecondaryButtonText,
    TextContainer,
    TitleText
} from './styled';

const InviteDeveloper = observer(() => {
    const navigate = useNavigate();
    const store = useStore();
    const { isFormPending, setInviteDeveloper } = store.authStore;
    const [isInviteDeveloperModal, setIsInviteDeveloperModal] = useState(false);

    const handleSkip = () => {
        setInviteDeveloper(false);
        navigate(ROUTE_PATHS.HOME);
    };

    return (
        <Container>
            <ChartCard>
                <ChartArea>
                    <Icon size='80px' color={COLORS.$gray40Black} component={() => <SpecificProductsIcon />} />
                </ChartArea>
                <TextContainer>
                    <TitleText level={3}>Invite your developer to Klickly</TitleText>
                    <DescriptionText type='descriptor1'>
                        We highly encourage you to invite a developer to help facilitate the technical setup of Klickly.
                        This process will involve configuring scripts, webhooks, etc.
                    </DescriptionText>
                </TextContainer>
            </ChartCard>

            <ButtonsContainer>
                <PrimaryButton
                    loading={isFormPending}
                    onClick={() => setIsInviteDeveloperModal(true)}
                    type='primary'
                    iconRight={<Icon size='24px' color={COLORS.$white} component={() => <EmailIcon />} />}
                    data-e2e='signup_invite-developer_btn'
                >
                    Send invite
                </PrimaryButton>
                <SecondaryButton onClick={handleSkip} data-e2e='signup_invite-developer-skip_btn'>
                    <SecondaryButtonText>Skip for now</SecondaryButtonText>
                </SecondaryButton>
            </ButtonsContainer>

            <InviteDeveloperModal isModalOpen={isInviteDeveloperModal} setIsModalOpen={setIsInviteDeveloperModal} />
        </Container>
    );
});

export default InviteDeveloper;
